enum OC_TYPES {
  INFORMATIVE_1 = 'informative-1',
  INFORMATIVE_2 = 'informative-2',
  DIALOGIC_1 = 'dialogic-1',
  DIALOGIC_2 = 'dialogic-2',
  PERSUASIVE_1 = 'persuasive-1',
  PERSUASIVE_2 = 'persuasive-2'
}

export default OC_TYPES;